import React, { useEffect, useRef } from "react";
import ReactPlayer from "react-player";

export default function RecordedClassPlayer(props) {
  const playerRef = useRef(null);
  // console.log({playerRef});
  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.seekTo(1200);
    }
  }, []);
  return (
    // <div id={"player"}></div>
    <>
      <ReactPlayer
        ref={playerRef}
        url={props.sources}
        playing={props.autoplay ? props.autoplay : false}
        allowFullScreen
        title="Recorded Class"
        width={"100%"}
        height={props.height ? props.height : "100%"}
        controls={true}
        // pip={true}
        progressInterval={60000}
        onStart={() => {
          props.handlePlaybackStart();
        }}
        onEnded={() => {
          props.handlePlaybackEnd();
        }}
        onPause={() => {
          console.log("video playback paused");
        }}
        onPlay={() => {
          console.log("video playback resumed/played");
        }}
        onProgress={(e) => {
          props.handlePlaybackProgress(playerRef.current.getCurrentTime());
        }}
        onSeek={() => {
          console.log("video playback Seeked");
        }}
      />
    </>
  );
}
